import { Button, Form, FormProps, Input } from 'antd';

import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

type FieldType = {
	currentPassword: string;
	newPassword: string;
	confirmPassword: string;
};

function ProfileChangePasswordComponent() {
	const [isLoading, setIsLoading] = useState(false);
	const [dataForm] = Form.useForm();

	const navigate = useNavigate();

	const onFinish: FormProps<FieldType>['onFinish'] = (values) => {
		console.log('Success:', values);
	};

	const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
		console.log('Failed:', errorInfo);
	};

	const onSubmit = () => {
		dataForm.submit();
		setIsLoading(true);
		setTimeout(() => {
			navigate('/profile/data');
		}, 1000);
	};

	const onDiscard = () => {
		navigate('/profile/data');
	};

	return (
		<>
			<div className="sectionContainer titled">
				<header>Profile Details</header>
				<main>
					<Form form={dataForm} name="basic" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off">
						<Form.Item<FieldType> label="Current password" labelAlign="left" name="currentPassword" rules={[{ required: true, message: 'Please input your current password!' }]}>
							<Input size="large" />
						</Form.Item>

						<Form.Item<FieldType> label="New password" labelAlign="left" name="newPassword" rules={[{ required: true, message: 'Please input new password!' }]}>
							<Input.Password size="large" />
						</Form.Item>

						<Form.Item<FieldType> label="Confirm password" labelAlign="left" name="confirmPassword" rules={[{ required: true, message: 'Please input confirm password!' }]}>
							<Input.Password size="large" />
						</Form.Item>
					</Form>
				</main>

				<footer className="d-flex justify-content-end gap-2">
					<Button className="discard" onClick={onDiscard}>
						Discard
					</Button>

					<Button type="primary" onClick={onSubmit} loading={isLoading}>
						Save changes
					</Button>
				</footer>
			</div>
		</>
	);
}

export default ProfileChangePasswordComponent;
